import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { usePageTitle } from '../lib/usePageTitle';

export const PaymentCancel: React.FC = () => {
    const navigate = useNavigate();
    usePageTitle('Payment Cancelled');

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8">
            <XCircle className="w-16 h-16 text-red-500 mb-4" />
            <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
            <p className="text-gray-600 mb-6">You have cancelled the checkout process. No charges were made.</p>
            <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
            >
                Return to Quote
            </button>
        </div>
    );
};
